import { elkjoptheme } from '@jotta/ui/themes/elkjop'
import { startApp } from '../App'

startApp(elkjoptheme)
